import UdeskLocales from 'UdeskLocales';
import React, { FC, memo, useCallback, useMemo, useState } from 'react';
import { useRequest } from 'ahooks';
import { Button, Form, InputNumber, message, Modal, Space, Spin } from 'udesk-ui';
import { getAgentConfigs, postAgentConfigs } from 'src/api/agentConfigs';
import { AgentConfigCreateRequest } from 'src/api/types';

interface TemplatePorps {
    onConfigSuccess?: () => void;
}

interface FormModel extends Omit<AgentConfigCreateRequest, 'id'> {}

const Template: FC<TemplatePorps> = memo((props) => {
    const { onConfigSuccess } = props;

    const [form] = Form.useForm<FormModel>();

    const { run: refresh, loading: getLoading } = useRequest(() => getAgentConfigs(), {
        onSuccess: (res) => {
            form.setFieldsValue({ agentTypeConfig: res.data?.agentTypeConfig });
        },
    });

    const [visible, setVisible] = useState(false);

    const onConfig = useCallback(() => {
        setVisible(true);
    }, []);

    const onCancel = useCallback(() => {
        setVisible(false);
    }, []);

    const [saveLoading, setSaveLoading] = useState(false);

    const onOk = useCallback(() => {
        form.validateFields().then((values) => {
            setSaveLoading(true);
            postAgentConfigs({
                agentTypeConfig: values.agentTypeConfig,
            })
                .then(() => {
                    message.success(
                        /* 保存成功 */ UdeskLocales['current'].pages.customerService
                            .customerInformation.components.agentTypeConfig.index.saveSuccessfully
                    );
                    onConfigSuccess?.();
                    refresh();
                    setVisible(false);
                })
                .finally(() => {
                    setSaveLoading(false);
                });
        });
    }, [form, onConfigSuccess, refresh]);

    const loading = useMemo(() => getLoading || saveLoading, [getLoading, saveLoading]);

    return (
        <>
            <Button onClick={onConfig}>
                {/* 客服类型配置 */}
                {
                    UdeskLocales['current'].pages.customerService.customerInformation.components
                        .agentTypeConfig.index.agentTypeConfiguration
                }
            </Button>

            <Modal
                title={
                    /* 客服类型配置 */ UdeskLocales['current'].pages.customerService
                        .customerInformation.components.agentTypeConfig.index.agentTypeConfiguration
                }
                visible={visible}
                onCancel={onCancel}
                onOk={onOk}
            >
                <Spin spinning={loading}>
                    <Form form={form}>
                        <Form.Item
                            label={
                                /* 新员工周期 */ UdeskLocales['current'].pages.customerService
                                    .customerInformation.components.agentTypeConfig.index
                                    .newEmployeeCycle
                            }
                        >
                            <Space>
                                <Form.Item
                                    noStyle
                                    name="agentTypeConfig"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                /* 请输入新员工周期 */ UdeskLocales['current'].pages
                                                    .customerService.customerInformation.components
                                                    .agentTypeConfig.index
                                                    .pleaseEnterNewEmployeeCycle,
                                        },
                                    ]}
                                >
                                    <InputNumber precision={0} min={1} style={{ width: 200 }} />
                                </Form.Item>

                                <div>
                                    {/* 天 */}
                                    {
                                        UdeskLocales['current'].pages.customerService
                                            .customerInformation.components.agentTypeConfig.index
                                            .day
                                    }
                                </div>
                            </Space>
                        </Form.Item>
                    </Form>
                </Spin>
            </Modal>
        </>
    );
});

export default Template;
